import { EventEntity } from '@/features/hazards';

/// Determines whether an event should be shown using the 511 popup (single-hazard MBF view).
/// The check on the `event-note` is to determine if the event has multiple hazards or is a single hazard event.
/// Only events from `external-mbf` source are eligible for the 511 popup. Events without a source are treated as eligible for backward compatibility.
// TODO: This is quite brittle, a better approach is to enrich this on the hazard API response.
export function is511Hazard(event: EventEntity | undefined): boolean {
  return !!event && !event.rawEvent['event-note'] && (!event.source || event.source === 'external-mbf');
}
